import React from "react";
import { motion } from "framer-motion";
import { VIEWPORT_ONCE_WIDE } from "../lib/motion";

const headingVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" },
    },
};

export default function SectionHeading({
    overline,
    title,
    description,
    align = "left",
}) {
    return (
        <motion.div
            variants={headingVariants}
            initial="hidden"
            whileInView="visible"
            viewport={VIEWPORT_ONCE_WIDE}
            className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
        >
            {overline && <p className="overline mb-4">{overline}</p>}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-white leading-[1.05]">
                {title}
            </h2>
            {description && (
                <p className="text-slate-400 text-base lg:text-lg mt-5 leading-relaxed">
                    {description}
                </p>
            )}
        </motion.div>
    );
}
